"use client"
import { useState, useEffect } from "react"
import axios from "axios"
import { useNavigate } from "react-router-dom"
import Select from "react-select"
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const AllOrders = () => {
  const [orders, setOrders] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)
  const [orderStatusList, setOrderStatusList] = useState([])

  const [searchTerm, setSearchTerm] = useState("")
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [currentPage, setCurrentPage] = useState(1)

  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false)
  const [editingOrder, setEditingOrder] = useState(null)


  //vendor payment status part
  // Vendor Payment
  const [isVendorPaymentPopupOpen, setIsVendorPaymentPopupOpen] = useState(false);
  const [selectedOrderForPayment, setSelectedOrderForPayment] = useState(null);
  const [transactionList, setTransactionList] = useState([]);
  const [selectedTransactionId, setSelectedTransactionId] = useState(null);
  const [transactionAmount, setTransactionAmount] = useState("");
  const [transactionDate, setTransactionDate] = useState("");
  const [transactionLoading, setTransactionLoading] = useState(false);


  const getSelectStyles = {
    control: (base) => ({
      ...base,
      minWidth: 140,
      height: 32,
      backgroundColor: "rgba(255,255,255,0.6)",  // slightly transparent white
      backdropFilter: "blur(4px)",               // clean glass effect
      borderRadius: 6,
      border: "1px solid #666",
      boxShadow: "none",
    }),
    singleValue: (base) => ({
      ...base,
      color: "#000",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    valueContainer: (base) => ({
      ...base,
      height: 28,
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: 28,
    }),
  };


  const navigate = useNavigate()

  useEffect(() => {
    fetchOrders()
    fetchOrderStatusList()
  }, [])
  const fetchOrderStatusList = async () => {
    try {
      const res = await axios.get(
        `https://logicx.premierlam.com/api/pixel-get-pixel-order-status`,
        { headers: { authorization: localStorage.getItem("accessToken") } }
      )
      setOrderStatusList(
        res.data.data.map((s) => ({ value: s.order_status, label: s.order_status }))
      )
    } catch (error) {
      console.log("Order statuses load failed")
    }
  }
  const fetchOrders = async () => {
    try {
      setIsLoading(true)
      const res = await axios.get(`https://logicx.premierlam.com/api/pixel-get-all-order`, {
        headers: { authorization: localStorage.getItem("accessToken") }
      })
      setOrders(sortOrders(res.data.data || []));
    } catch {
      setError("Failed to fetch orders")
    } finally {
      setIsLoading(false)
    }
  }

  const handleEditClick = (order) => {
    setEditingOrder(order)
    setIsEditDialogOpen(true)
  }
  const sortOrders = (orders) => {
    return [...orders].sort(
      (a, b) => new Date(b.created_at) - new Date(a.created_at)
    );
  };

  const filteredOrders = orders.filter(
    (o) =>
      o.order_id?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      o.customer_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      o.order_medium?.toLowerCase().includes(searchTerm.toLowerCase())
  )

  const totalPages = Math.ceil(filteredOrders.length / rowsPerPage)
  const paginatedOrders = filteredOrders.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  )

  const formatDate = (date) =>
    new Date(date).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" })

  const handleOrderStatusUpdate = async (orderId, newStatus) => {
    try {
      await axios.put(
        `https://logicx.premierlam.com/api/update-order-status/${orderId}`,
        { order_status: newStatus },
        {
          headers: {
            authorization: localStorage.getItem("accessToken"),
            "Content-Type": "application/json",
          },
        }
      );

      // Update UI without refresh
      setOrders((prev) =>
        prev.map((o) =>
          o.order_id === orderId ? { ...o, order_status: newStatus } : o
        )
      );
      toast.success(`Order status updated to ${newStatus}`, {
        position: "top-right",
        autoClose: 2000
      });


      console.log("Order status updated");
    } catch (error) {
      console.log("Error updating order status", error);
    }
  };
  const whatsappStatusOptions = [
    { value: "Added", label: "Added" },
    { value: "Not Added", label: "Not Added" }
  ]

  const amountStatusOptions = [
    { value: "Received", label: "Received" },
    { value: "Not Received", label: "Not Received" }
  ]
  const vendorOrderStatusOptions = [
    { value: "pending", label: "pending" },
    { value: "packed", label: "packed" }
  ];
  const handleVendorOrderStatusUpdate = async (orderId, newStatus) => {
    try {
      await axios.put(
        `https://logicx.premierlam.com/api/update-vendor-order-status/${orderId}`,
        { vendor_order_status: newStatus },
        {
          headers: {
            authorization: localStorage.getItem("accessToken"),
            "Content-Type": "application/json",
          },
        }
      );

      setOrders(prev =>
        prev.map(o =>
          o.id === orderId ? { ...o, vendor_order_status: newStatus } : o
        )
      );
      toast.success(`Vendor order status updated to ${newStatus}`, {
        position: "top-right",
        autoClose: 2000
      });

    } catch (err) {
      console.log("Error updating vendor order status", err);
    }
  };

  const handleWhatsappStatusUpdate = async (orderId, newStatus) => {
    try {
      await axios.put(
        `https://logicx.premierlam.com/api/pixel-update-whatsapp-automation-status/${orderId}`,
        { whatsapp_automation_status: newStatus },
        {
          headers: {
            authorization: localStorage.getItem("accessToken"),
            "Content-Type": "application/json",
          },
        }
      );

      setOrders(prev =>
        prev.map(o =>
          o.order_id === orderId ? { ...o, what_app_automation_status: newStatus } : o
        )
      );
      toast.success(`WhatsApp status updated to ${newStatus}`, {
        position: "top-right",
        autoClose: 2000
      });

    } catch (err) {
      console.log("Error updating WhatsApp status", err);
    }
  };
  const handleAmountStatusUpdate = async (orderId, newStatus) => {
    try {
      await axios.put(
        `https://logicx.premierlam.com/api/pixel-update-order-amount-status/${orderId}`,
        { amount_status: newStatus },
        {
          headers: {
            authorization: localStorage.getItem("accessToken"),
            "Content-Type": "application/json",
          },
        }
      );

      setOrders(prev =>
        prev.map(o =>
          o.order_id === orderId ? { ...o, amount_status: newStatus } : o
        )
      );
      toast.success(`Amount status updated to ${newStatus}`, {
        position: "top-right",
        autoClose: 2000
      });

    } catch (err) {
      console.log("Error updating amount status", err);
    }
  };
  const fetchTransactionIds = async () => {
    try {
      setTransactionLoading(true);

      const res = await axios.get(
        "https://logicx.premierlam.com/api/pixel-get-all-the-transaction-ids",
        {
          headers: { authorization: localStorage.getItem("accessToken") }
        }
      );

      const list = res.data.data || [];

      const mapped = list.map(t => ({
        value: t.transaction_id,
        label: t.transaction_id
      }));

      setTransactionList(mapped);

    } catch (err) {
      console.log("Error fetching transactions", err);
    } finally {
      // Open popup AFTER list is loaded
      setTransactionLoading(false);
      setIsVendorPaymentPopupOpen(true);
    }
  };


  const fetchTransactionDetails = async (tid) => {
    try {
      const res = await axios.get(
        `https://logicx.premierlam.com/api/pixel-get-transaction-details/${tid}`,
        {
          headers: { authorization: localStorage.getItem("accessToken") }
        }
      );

      const d = res.data.data[0];
      setTransactionAmount(d.payment_amount);
      setTransactionDate(d.payment_date);
    } catch (err) {
      console.log("Error fetching transaction details", err);
    }
  };
  // inside your component

  const handleVendorPaymentStatusChange = async (order, newStatus) => {
    if (newStatus === "paid") {
      // open popup and set the order object used later
      setSelectedOrderForPayment(order);
      setSelectedTransactionId(null);
      setTransactionAmount("");
      setTransactionDate("");
      fetchTransactionIds(); // popup opens AFTER list loads
      return;
    }

    // update pending directly
    try {
      const orderId = order?.order_id;
      if (!orderId) throw new Error("Missing order_id for pending update");

      const url = `https://logicx.premierlam.com/api/pixel-update-vendor-payment-status/${encodeURIComponent(orderId)}`;
      const headers = { authorization: localStorage.getItem("accessToken"), "Content-Type": "application/json" };

      const res = await axios.put(url, { vendor_payment_status: "pending" }, { headers });
      console.log("Pending update response:", res.data);

      // correctly update only that order row
      setOrders(prev =>
        prev.map(o => (o.order_id === orderId ? { ...o, vendor_payment_status: "pending", vendor_payment_transaction_id: null } : o))
      );

      toast.success("Vendor payment status updated to pending", { position: "top-right", autoClose: 2000 });
    } catch (err) {
      console.error("Error updating vendor payment to pending:", err.response?.status, err.response?.data || err.message || err);
      toast.error("Failed to update vendor payment to pending");
    }
  };

  const handleVendorPaymentUpdate = async () => {
    try {
      const orderObj = selectedOrderForPayment;
      if (!orderObj || !orderObj.order_id) {
        throw new Error("No order selected for payment update");
      }
      if (!selectedTransactionId) {
        throw new Error("No transaction id selected");
      }

      const orderId = orderObj.order_id;
      const encodedOrderId = encodeURIComponent(orderId);
      const headers = { authorization: localStorage.getItem("accessToken"), "Content-Type": "application/json" };

      // 1) Update transaction ID
      console.log("PUT transaction details ->", encodedOrderId, selectedTransactionId);
      const res1 = await axios.put(
        `https://logicx.premierlam.com/api/pixel-update-vendor-order-transaction-details/${encodedOrderId}`,
        { transaction_id: selectedTransactionId },
        { headers }
      );
      console.log("transaction details update response:", res1.data);

      // 2) Update vendor payment status
      console.log("PUT vendor_payment_status ->", encodedOrderId);
      const res2 = await axios.put(
        `https://logicx.premierlam.com/api/pixel-update-vendor-payment-status/${encodedOrderId}`,
        { vendor_payment_status: "paid" },
        { headers }
      );
      console.log("vendor payment status update response:", res2.data);

      // 3) Update UI
      setOrders(prev =>
        prev.map(o => (o.order_id === orderId ? { ...o, vendor_payment_status: "paid", vendor_payment_transaction_id: selectedTransactionId } : o))
      );

      toast.success("Vendor payment marked as PAID", { position: "top-right", autoClose: 2000 });

      // Close popup & clear selection
      setIsVendorPaymentPopupOpen(false);
      setSelectedTransactionId(null);
      setTransactionAmount("");
      setTransactionDate("");
    } catch (err) {
      console.error("Error updating vendor payment:", err.response?.status, err.response?.data || err.message || err);
      // Show server message if available
      const serverMsg = err.response?.data?.message || err.response?.data || err.message;
      toast.error("Failed to update vendor payment: " + (serverMsg || ""));
    }
  };

  const getRowColor = (status) => {
    const colors = {
      "Pending": "#f8d6d6",              // lighter red
      "Ready to ship": "#f3d3f0",        // lighter pink/purple
      "Order Confirmed": "#d6fff7",      // lighter teal
      "Order Picked up": "#f3f6c8",      // pale yellow-green
      "Order Delivered": "#d5f8d2",      // soft green
      "RTO Processed": "#e4e0f8",        // soft lavender
      "Order Returned": "#f1d7d7",       // soft rose
      "Customer Rejected": "#ffebd6",    // pale orange
      "Cancelled by Customer Before": "#ececec", // light grey
      "Cancelled by Customer After": "#f0dff7",  // light purple
      "Calculate Profit": "#f7e9c1",     // soft gold
    };


    return colors[status] || "transparent";
  };

  return (

    <div className="p-4 bg-gray-50 min-h-screen">
      <ToastContainer />

      <div className="max-w-7xl mx-auto">

        {/* HEADER */}
        <div className="flex justify-between items-start mb-6">
          <div>
            <h1 className="text-2xl font-semibold text-gray-900 mb-1">Orders</h1>
            <p className="text-gray-500">Manage your orders</p>
          </div>

          <button
            onClick={() => (window.location.href = "/add-order")}
            className="flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-lg transition-colors"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
            Add Order
          </button>
        </div>

        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
          <input
            type="text"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange-500 outline-none w-64 mb-4"
          />

          {/* TABLE */}
          <div className="overflow-x-auto">
            {isLoading ? (
              <div className="text-center py-6 text-gray-500">Loading...</div>
            ) : (
              <table className="w-full border-collapse ">
                <thead>
                  <tr className="border-b border-gray-200 text-gray-600 text-sm">
                    <th className="py-3 px-4 text-left">Actions</th>
                    <th className="py-3 px-4 text-left w-52">Order ID</th>
                    <th className="py-3 px-4 text-left " style={{ width: "200px" }}>Order Date</th>
                    <th className="py-3 px-4 text-left">Medium</th>
                    <th className="py-3 px-4 text-left">Vendor</th>
                    <th className="py-3 px-4 text-left">Customer</th>
                    <th className="py-3 px-4 text-left">Phone</th>
                    <th className="py-3 px-4 text-left">WhatsApp</th>
                    <th className="py-3 px-4 text-left">Order Status</th>

                    <th className="py-3 px-4 text-left">Amount Status</th>


                    <th className="py-3 px-4 text-left">Vendor Pay Status</th>

                    <th className="py-3 px-4 text-left">Vendor Order Status</th>

                    <th className="py-3 px-4 text-left">Created</th>

                  </tr>
                </thead>

                <tbody>
                  {paginatedOrders.map((o) => (
                    // <tr key={o.id} className=" border-b hover:bg-gray-50">
                    <tr
                      key={o.id}
                      className="border-b"
                      style={{ backgroundColor: getRowColor(o.order_status) }}
                    >

                      <td className="  align-middle py-3 px-4 ">
                        <div className="flex items-center justify-start gap-2 h-full">

                          <button
                            onClick={() => window.open(`/view-order/${o.order_id}`, "_blank")}
                            className="p-1 text-gray-400 hover:text-blue-600 transition-colors"
                          >

                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                              />
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                              />
                            </svg>
                          </button>
                          <button
                            onClick={() => navigate(`/add-item/${o.order_id}/${o.order_date}`)}
                            className="p-1 text-gray-400 hover:text-blue-600 transition-colors">
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v12m6-6H6" />
                            </svg>
                          </button>
                          <button
                            onClick={() => navigate(`/edit-order/${o.id}`)}
                            className="p-1 text-gray-400 hover:text-blue-600 transition-colors"
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                              />
                            </svg>
                          </button>
                          <button
                            // onClick={() => handleDeleteClick(p)}
                            className="p-1 text-gray-400 hover:text-red-600 transition-colors"
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                          </button>
                        </div>
                      </td>
                      <td className="py-3 px-4 text-sm">{o.order_id || "Not Set"}</td>
                      <td className="py-3 px-4 text-sm w-52" style={{ width: "200px" }}>{o.order_date || "Not Set"}</td>
                      <td className="py-3 px-4 text-sm">{o.order_medium || "Not Set"}</td>
                      <td className="py-3 px-4 text-sm">{o.vendor_name || "Not Set"}</td>
                      <td className="py-3 px-4 text-sm">{o.customer_name || "Not Set"}</td>
                      <td className="py-3 px-4 text-sm">{o.phone_number || "Not Set"}</td>
                      {/* <td className="py-3 px-4 text-sm">{o.what_app_automation_status || "Not Set"}</td> */}
                      <td className="py-3 px-4 text-sm">
                        <Select
                          className="text-sm"
                          options={whatsappStatusOptions}
                          value={
                            o.what_app_automation_status
                              ? { value: o.what_app_automation_status, label: o.what_app_automation_status }
                              : null
                          }
                          placeholder="Select"
                          onChange={(selected) =>
                            handleWhatsappStatusUpdate(o.order_id, selected.value)
                          }
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          styles={getSelectStyles}
                        />
                      </td>

                      <td className="py-3 px-4 text-sm">
                        <Select
                          className="text-sm w-48"
                          options={orderStatusList}
                          value={o.order_status ? { value: o.order_status, label: o.order_status } : null}
                          placeholder="Select"
                          onChange={(selected) =>
                            handleOrderStatusUpdate(o.order_id, selected.value)
                          }
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          // styles={{
                          //   control: (base) => ({ ...base, minWidth: 140, height: 32, paddingLeft: 0 }),
                          //   indicatorsContainer: (base) => ({ ...base, height: 28 }),
                          //   valueContainer: (base) => ({ ...base, height: 28, paddingTop: 0, paddingBottom: 0 }),
                          //   menu: (base) => ({ ...base, zIndex: 9999 }),
                          // }}
                          styles={getSelectStyles}
                        />
                      </td>



                      <td className="py-3 px-4 text-sm">
                        <Select
                          className="text-sm"
                          options={amountStatusOptions}
                          value={
                            o.amount_status
                              ? { value: o.amount_status, label: o.amount_status }
                              : { value: "Not Received", label: "Not Received" }
                          }
                          placeholder="Select"
                          onChange={(selected) =>
                            handleAmountStatusUpdate(o.order_id, selected.value)
                          }
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          styles={getSelectStyles}
                        />
                      </td>


                      {/* <td className="py-3 px-4 text-sm">{o.vendor_payment_status || "Not Set"}</td> */}
                      <td className="py-3 px-4 text-sm">
                        <Select
                          className="text-sm"
                          options={[
                            { value: "pending", label: "pending" },
                            { value: "paid", label: "paid" }
                          ]}
                          value={
                            o.vendor_payment_status
                              ? { value: o.vendor_payment_status, label: o.vendor_payment_status }
                              : { value: "pending", label: "pending" }
                          }
                          placeholder="Select"
                          onChange={(selected) =>
                            handleVendorPaymentStatusChange(o, selected.value)
                          }
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          styles={{
                            control: (base) => ({
                              ...base,
                              minWidth: 140,
                              height: 32,
                              backgroundColor:
                                o.vendor_payment_status === "paid" ? "#06c167" : "#ff4f4f",
                              color: "white",
                            }),
                            singleValue: (base) => ({
                              ...base,
                              color: "white",
                              fontWeight: "bold",
                            }),
                            menu: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                        />
                      </td>


                      {/* <td className="py-3 px-4 text-sm">{o.vendor_order_status || "Not Set"}</td> */}
                      <td className="py-3 px-4 text-sm">
                        <Select
                          className="text-sm"
                          options={vendorOrderStatusOptions}
                          value={
                            o.vendor_order_status
                              ? { value: o.vendor_order_status, label: o.vendor_order_status }
                              : null
                          }
                          placeholder="Select"
                          onChange={(selected) =>
                            handleVendorOrderStatusUpdate(o.id, selected.value)
                          }
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          styles={getSelectStyles}
                        />
                      </td>


                      <td className="py-3 px-4 text-sm">{formatDate(o.created_at)}</td>

                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>

          {/* PAGINATION */}
          <div className="flex justify-between items-center mt-4 text-sm text-gray-600">
            <span>Page {currentPage} of {totalPages}</span>
            <div className="flex gap-2">
              <button
                onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
                disabled={currentPage === 1}
                className="px-3 py-1 border rounded-md disabled:opacity-50"
              >
                Prev
              </button>
              <button
                onClick={() => currentPage < totalPages && setCurrentPage(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="px-3 py-1 border rounded-md disabled:opacity-50"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* EDIT MODAL PLACEHOLDER */}
      {isEditDialogOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 relative w-full max-w-md">
            <button
              className="absolute top-3 right-4 text-gray-400 hover:text-gray-700 text-xl"
              onClick={() => setIsEditDialogOpen(false)}
            >
              ✖
            </button>
            <h2 className="text-lg font-semibold">Edit Order (Coming Soon)</h2>
          </div>
        </div>
      )}
      {/* transaction popup after status changed to paid */}
      {isVendorPaymentPopupOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-md shadow-xl relative">

            <h2 className="text-lg font-semibold mb-4">Vendor Payment Update</h2>

            {/* TRANSACTION ID */}
            <label className="text-sm font-medium">Transaction ID</label>
            <Select
              classNamePrefix="react-select"
              options={transactionList}
              isLoading={transactionLoading}
              placeholder={transactionLoading ? "Loading..." : "Select Transaction ID"}
              value={
                selectedTransactionId
                  ? { value: selectedTransactionId, label: selectedTransactionId }
                  : null
              }
              onChange={(sel) => {
                setSelectedTransactionId(sel.value);
                fetchTransactionDetails(sel.value);
              }}
              // menuPortalTarget={document.body}
              menuPosition="fixed"
            />



            {/* AMOUNT */}
            <label className="text-sm font-medium">Amount Paid</label>
            <input
              type="text"
              value={transactionAmount}
              readOnly
              className="w-full mb-4 px-3 py-2 border rounded-md bg-gray-100"
            />

            {/* DATE */}
            <label className="text-sm font-medium">Payment Date</label>
            <input
              type="text"
              value={transactionDate}
              readOnly
              className="w-full mb-4 px-3 py-2 border rounded-md bg-gray-100"
            />

            {/* BUTTONS */}
            <div className="flex justify-end gap-3">
              <button
                className="px-4 py-2 bg-gray-300 rounded-md"
                onClick={() => setIsVendorPaymentPopupOpen(false)}
              >
                Cancel
              </button>

              <button
                className="px-4 py-2 bg-green-600 text-white rounded-md"
                onClick={handleVendorPaymentUpdate}
                disabled={!selectedTransactionId}
              >
                Update
              </button>
            </div>

          </div>
        </div>
      )}

    </div>
  )
}

export default AllOrders
